import React from "react";
import { FiGithub} from "react-icons/fi";
import { FaWhatsapp, FaLinkedin } from 'react-icons/fa';

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://wa.me/message/5PEOPAQWQTRPF1" className="home__social-icon" target="_blank">
                <FaWhatsapp size={24} />
            </a>
            <a href="https://github.com/GabrielMorais2" className="home__social-icon" target="_blank">
                <FiGithub size={24} />
            </a>
            <a href="https://www.linkedin.com/in/gabrielmoraes12/" className="home__social-icon" target="_blank">
                <FaLinkedin size={24}/>
            </a>
        </div> 
    ); 
}

export default Social;